import './TQTopContributersButton.scss';

import React from 'react';

import { IoChevronForward } from 'react-icons/io5';
import TMIcon from 'tm-icons-library';

interface TQTopContributersButtonProps {
  onClick?: () => void;
  className?: string;
}

const TQTopContributersButton: React.FC<TQTopContributersButtonProps> = ({
  onClick,
  className = '',
}) => {
  return (
    <button
      type="button"
      className={`tq-top-contributors-btn ${className}`.trim()}
      onClick={onClick}
    >
      <span className="tq-top-contributors-btn__icon-wrap">
        <TMIcon
          name="trophy"
          size={22}
          color="#fff"
          className="tq-top-contributors-btn__icon"
        />
      </span>
      <span className="tq-top-contributors-btn__label">Top Contributors</span>
      <span className="tq-top-contributors-btn__chevron" aria-hidden>
        <IoChevronForward size={20} />
      </span>
    </button>
  );
};

export default TQTopContributersButton;
